"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var graphql_tag_1 = require("graphql-tag");
var react_apollo_1 = require("react-apollo");
var Checkbox_1 = require("@material-ui/core/Checkbox");
var FormControlLabel_1 = require("@material-ui/core/FormControlLabel");
var Grid_1 = require("@material-ui/core/Grid");
var Link_1 = require("@material-ui/core/Link");
var Typography_1 = require("@material-ui/core/Typography");
var AutoCompleteSelects_1 = require("src/bookstore/AutoCompleteSelects");
var CardList_1 = require("src/bookstore/CardList");
var Loading_1 = require("src/bookstore/Loading");
var SiteHeader_1 = require("src/bookstore/SiteHeader");
var CurrentUser_1 = require("src/CurrentUser");
var Snackbar_1 = require("src/Snackbar");
var ProductCard_1 = require("./ProductCard");
exports.searchProductsGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nquery ProductSearch ($searchParameters: BookSearchParametersInput!){\n  searchBooks (searchParameters: $searchParameters) {\n    ...ProductCardFragment\n  }\n}\n", "\n"], ["\nquery ProductSearch ($searchParameters: BookSearchParametersInput!){\n  searchBooks (searchParameters: $searchParameters) {\n    ...ProductCardFragment\n  }\n}\n", "\n"])), ProductCard_1.ProductCardFragmentGQL);
var renderProductCard = function (bookData) {
    return React.createElement(ProductCard_1.default, { bookData: bookData });
};
var keyForProductCard = function (bookData) { return String(bookData.id); };
/**
 * Render Product Cards into cardlist, populate with product search query
 */
var ProductIndexPage = /** @class */ (function (_super) {
    __extends(ProductIndexPage, _super);
    function ProductIndexPage(props) {
        var _this = _super.call(this, props) || this;
        _this.onUniversityChange = function (_a) {
            var label = _a.label, value = _a.value;
            if (value === null) {
                return _this.resetSearchParams();
            }
            _this.setState({
                universityValue: { value: value, label: label }
            });
        };
        _this.resetSearchParams = function () {
            _this.setState({ universityValue: { value: null, label: 'university' } });
        };
        _this.limitToShelfChanged = function (e) {
            _this.setState({ showAll: e.target.checked === true });
        };
        _this.state = {
            universityValue: _this.loadUniversityValueFromProps(props),
            showAll: true
        };
        return _this;
    }
    ProductIndexPage.prototype.loadUniversityValueFromProps = function (props) {
        if (props.currentUser.loggedInUser === null || props.currentUser.loggedInUser.universityId == null) {
            return undefined;
        }
        var value = props.currentUser.loggedInUser.universityId || 0;
        var label = props.currentUser.loggedInUser.university &&
            props.currentUser.loggedInUser.university.displayName || '';
        return { value: value, label: label };
    };
    ProductIndexPage.prototype.render = function () {
        var _this = this;
        var _a;
        if (this.props.currentUser.loading) {
            return React.createElement(Loading_1.default, null);
        }
        var loggedInUser = this.props.currentUser.loggedInUser;
        var defaultUniversityValue = this.loadUniversityValueFromProps(this.props);
        var _b = this.state, _c = _b.universityValue, universityValue = _c === void 0 ? defaultUniversityValue : _c, showAll = _b.showAll;
        var universityIds = universityValue && universityValue.value && [universityValue.value] || undefined;
        var isRowanUser = ((_a = loggedInUser) === null || _a === void 0 ? void 0 : _a.isRowanUser) === true;
        var isOnShelf = false;
        var limitToOwned = null;
        // if a rowan user wants to see everything
        if (this.state.showAll && isRowanUser) {
            isOnShelf = null;
            limitToOwned = false;
        }
        return (React.createElement("div", { style: { marginTop: 36, width: '100%' } },
            React.createElement(SiteHeader_1.SubHeader, null,
                React.createElement(Grid_1.default, { item: true, style: { width: 250 } },
                    React.createElement(AutoCompleteSelects_1.UniversityAutoComplete, { allowNull: true, nullOptionLabel: "All Products", onChange: this.onUniversityChange, value: this.state.universityValue, style: { width: 280 }, state: "default" }))),
            isRowanUser && (React.createElement(Grid_1.default, { container: true, alignItems: "flex-end" },
                React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, { onChange: this.limitToShelfChanged, checked: showAll, color: "primary", style: { zIndex: 0 } }), label: "Show All" }))),
            React.createElement(react_apollo_1.Query, { query: exports.searchProductsGQL, fetchPolicy: "no-cache", variables: {
                    searchParameters: {
                        isOnShelf: isOnShelf,
                        limitToOwned: limitToOwned,
                        universityIds: universityIds
                    }
                } }, function (_a) {
                var loading = _a.loading, error = _a.error, data = _a.data;
                if (loading) {
                    return React.createElement(Loading_1.default, null);
                }
                if (error) {
                    return React.createElement(Snackbar_1.CustomSnackbar, { variant: "error", message: error.message });
                }
                if (data === undefined) {
                    return React.createElement(Typography_1.default, { variant: "h3" }, "Unable to find any products");
                }
                if (data.searchBooks.length === 0) {
                    return (React.createElement(Typography_1.default, { variant: "h3" },
                        "No results found. Try ",
                        React.createElement(Link_1.default, { onClick: _this.resetSearchParams }, "search all products.")));
                }
                var booksWithProduct = data.searchBooks.filter(function (book) { return book.product !== null; });
                return React.createElement(CardList_1.CardList, { items: booksWithProduct, listItem: renderProductCard, keyForItem: keyForProductCard });
            })));
    };
    return ProductIndexPage;
}(React.Component));
exports.default = CurrentUser_1.withCurrentUser(ProductIndexPage);
var templateObject_1;
